import { Button } from '@runtime/components/ui/Button'
import { FormField } from '@runtime/components/ui/Form'
import { Text } from '@runtime/components/ui/Text'
import type { I18nT } from '@runtime/core/i18n/i18n'
import type { UserProfile } from '@runtime/features/profile/model/profileTypes'
import styles from '@runtime/features/profile/account/tabs/ProfileTab.module.scss'

type ProfileTabProps = {
  t: I18nT
  user: UserProfile | null
  exportBusy: boolean
  exportError: string
  deleteBusy: boolean
  deleteError: string
  onLogout: () => void
  onSave: () => void
  onExportData: () => void
  onDeleteAccount: () => void
}

export default function ProfileTab({
  t,
  user,
  exportBusy,
  exportError,
  deleteBusy,
  deleteError,
  onLogout,
  onSave,
  onExportData,
  onDeleteAccount,
}: ProfileTabProps) {
  return (
    <div className={styles.loginForm} data-testid="login-form">
      <div className={styles.loginSectionTitle}>
        {t('profile.identity.title')}
      </div>

      <div className={styles.loginFieldStack}>
        <Text variant="legend" className={styles.legend}>
          {t('online.profile.nick')}
        </Text>
        <FormField round value={user?.pseudo || ''} disabled readOnly />
      </div>

      <div className={styles.loginFieldStack}>
        <Text variant="legend" className={styles.legend}>
          {t('profile.identity.emailLabel')}
        </Text>
        <FormField round value={user?.email || ''} disabled readOnly />
      </div>

      <div className={styles.loginFormFooter} data-testid="login-form-footer">
        <Button
          type="button"
          variant="ghost"
          data-testid="logout-action"
          onClick={onLogout}
        >
          {t('profile.buttons.logout')}
        </Button>
        <Button type="button" onClick={onSave} disabled={!user}>
          {t('profile.buttons.save')}
        </Button>
      </div>

      <div className={styles.loginDataBlock}>
        <div className={styles.loginSectionTitle}>
          {t('profile.auth.dataTitle')}
        </div>
        {exportError && (
          <Text variant="legend" className={styles.noticeError}>
            {exportError}
          </Text>
        )}
        {deleteError && (
          <Text variant="legend" className={styles.noticeError}>
            {deleteError}
          </Text>
        )}
        <div
          className={`${styles.loginFormFooter} ${styles.loginFormFooterSplit}`}
        >
          <Button
            type="button"
            variant="ghost"
            onClick={onExportData}
            disabled={exportBusy}
          >
            {exportBusy
              ? t('profile.auth.loading')
              : t('profile.auth.exportAction')}
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={onDeleteAccount}
            disabled={deleteBusy}
          >
            {deleteBusy
              ? t('profile.auth.loading')
              : t('profile.auth.deleteAction')}
          </Button>
        </div>
      </div>
    </div>
  )
}
